module.exports = __webpack_public_path__ + "static/media/add.e6af148c.svg";